import { render, staticRenderFns } from "./RegisterBottom.vue?vue&type=template&id=4666f629&"
import script from "./RegisterBottom.vue?vue&type=script&lang=js&"
export * from "./RegisterBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports